export default {"src":"/_next/static/media/pipl.f87f322b.svg","height":80,"width":130};